import { UserAllowedRoutes, UserRequiredRoute } from '../../core/models/allowed-required-routes';

export function isUserAuthorized(requiredRoute: UserRequiredRoute, userAllowedRoutes: UserAllowedRoutes): boolean {
  if (userAllowedRoutes == null) return false;

  const pathMethods = userAllowedRoutes[requiredRoute.path];
  return pathMethods && pathMethods.has(requiredRoute.method);
}
